import Vue from 'vue';
import Vuex from 'vuex';
import { getUserInfo } from '../api/user';
import { getWebInfo } from '../api/home';
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
    token: getToken(),
    hasLogin: false,// 是否登录了
    loginDialog: false,
    mainDialog: false,
    topic: [],
    user: {},
    webInfo: {
        registerNum: 0,
        studyNum: 0,
        courseNum: 0,
        accessNum: 0
    }
};

const actions = {
    // 从接口获取网站信息
    GetWebInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getWebInfo().then(res => {
                commit('SET_WEBINFO', res.data);
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 从接口获取用户信息
    GetInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getUserInfo().then(res => {
                commit('SET_USER', res.data)
                commit('HASLOGIN')
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    //从缓存获取用户信息
    setUser(store, provider) {
        console.log(provider)
        window.localStorage.setItem('user_data', JSON.stringify(provider));
        store.commit('SET_USER', provider)
    },
    // 存储token
    SetToken(store, provider) {
        console.log(provider);
        store.commit('SET_TOKEN', provider);
    },
    setTopic(store, provider) {
        store.commit('SET_TOPIC', provider);
    },
    // 退出登录
    LogOut({ commit }) {
        commit('REMOVE_TOKEN', '')
        removeToken();
    },
};

const mutations = {
     // 网站信息赋值
     SET_WEBINFO: (state, provider) => {
        state.webInfo = provider
    },
    SET_TOPIC: (state, provider) => {
        for (var i = 0; i < state.topic.length; i++) {
            if (state.topic[i].id === provider.id) {
                state.topic[i].index = provider.index;
                window.localStorage.setItem('topic_data', JSON.stringify(state.topic));
                return true;
            }
        }
        state.topic.push(provider);
        window.localStorage.setItem('topic_data', JSON.stringify(state.topic));
    },
    RESET_TOPIC(state, list) {
        state.topic = list;
    },
    //存储token
    SET_TOKEN: (state, token) => {
        state.token = token
        state.hasLogin = true;
        console.log("用户信息存储成功")
        /* state.loginDialog = false; */
        setToken(token)
    },
    // 改变登录状态
    HASLOGIN: (state) => {
        state.hasLogin = true;
    },
    // user赋值
    SET_USER: (state, user) => {
        let result = window.localStorage.getItem('topic_data');
        if(result) {
            state.topic = JSON.parse(result);
        }
        window.localStorage.setItem('user_data', JSON.stringify(user));
        state.user = user
    },
    // 删除token
    REMOVE_TOKEN: (state) => {
        state.token = '';
        state.user = {};
        window.localStorage.removeItem('user_data');
        state.hasLogin = false;
    }
};

const getters = {
    user: state => state.user
}

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters
})